export const LibLazyComponents = {
  bitmovinPlayer: 'bitmovinPlayer',
}
